import { render, staticRenderFns } from "./TrainingDialog.vue?vue&type=template&id=8aede8aa&scoped=true"
import script from "./TrainingDialog.vue?vue&type=script&lang=js"
export * from "./TrainingDialog.vue?vue&type=script&lang=js"
import style0 from "./TrainingDialog.vue?vue&type=style&index=0&id=8aede8aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aede8aa",
  null
  
)

export default component.exports